import type { RouterConfig } from '@nuxt/schema';

const OWNS_ITS_SCROLL = new Set(['/', '/explore']);

export default <RouterConfig>{
  scrollBehavior(to, from, savedPosition) {
    const path = to.path.replace(/\/+$/, '') || '/';

    if (OWNS_ITS_SCROLL.has(path)) return false;

    // The first navigation of a page load is not a navigation anybody made.
    //
    // scrollBehavior runs for it exactly as it runs for a link, and returning
    // top: 0 there undoes the restore: the blocking script in nuxt.config has
    // already put the page back where it was left, on the first frame, and this
    // scrolled it to the top a moment later. That is why the two pages listed
    // above came back correctly and every other long page did not.
    //
    // A hash is still honoured, since arriving at one is a destination somebody
    // asked for rather than a position they are being returned to.
    if (!from.matched.length && !to.hash) return false;
    if (savedPosition) return savedPosition;
    if (to.hash) return { el: to.hash };

    return { top: 0 };
  },
};
